import React from "react";
import { motion } from "framer-motion";
import "./caseStudies.css";
import CaseStudyCard from "./CaseStudyCard";

const CaseStudies = () => {
  const caseStudies = [
    {
      coin: "Phil Coin",
      result: "80% Price Surge",
      duration: "2-Day Strategic Awareness Campaign",
      strategy: "77 KOLs across X (Twitter) & Telegram",
      achievement:
        "Price pumped from $0.001668 → $0.002853, driving 319K+ total views, 4.4K likes, and 1.7K comments across all posts",
      delay: 0.1,
    },
  ];

  return (
    <section className="case-studies-section" id="case-studies">
      <div className="case-studies-container">
        {/* Header */}
        <motion.div
          className="case-studies-header"
          initial={{ opacity: 1, y: 0 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="case-studies-heading">Case Studies</h2>
          <p className="case-studies-subtitle">Quality results for ambitious crypto teams backed by our 2+ years experience and 400+ KOL network.</p>
        </motion.div>

        {/* Case Studies Grid */}
        <div className="case-studies-grid">
          {caseStudies.map((study, index) => (
            <CaseStudyCard
              key={index}
              coin={study.coin}
              result={study.result}
              duration={study.duration}
              strategy={study.strategy}
              achievement={study.achievement}
              delay={study.delay}
            />
          ))}
        </div>

        <div className="cs-cta">
          <a className="btn-primary" href="#contact">Start a Campaign</a>
        </div>
      </div>
    </section>
  );
};

export default CaseStudies;

